import React from 'react';

export default () => (
  <div
    className="pt-4"
    style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      background: 'rgba(255,255,255,0.5)',
      textAlign: 'center',
      zIndex: 2,
    }}
  ><i className="fa fa-spin fa-spinner fa-3x" />
  </div>
);



// WEBPACK FOOTER //
// ./src/views/_Lessons/Loading.js